export default __webpack_public_path__ + "static/Slack-f57b65432b5bd5f2f30bcddb85db66f2.png";